import BackButtonToolbar from "features/BackButtonToolbar";
import React from "react";
import { Create, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";

const CreateHealthcareCourses = () => {
  return (
    <Create
      title="Създаване на курс по здравни грижи"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm>
        <SaveForm />
      </SimpleForm>
    </Create>
  );
};

export default CreateHealthcareCourses;
